import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import RttRoundedIcon from '@mui/icons-material/RttRounded';
import AutoFixHighOutlinedIcon from '@mui/icons-material/AutoFixHighOutlined';
import DrawOutlinedIcon from '@mui/icons-material/DrawOutlined';

import { useProject } from '../../context/ProjectContext';
import IconTab from '../../id8/components/icon-tab/IconTab';
import { ACTIV8_TABS } from '../../constants';

const useActiv8Tabs = () => {
  const { t } = useTranslation('id8');
  const { projectVariant } = useProject();

  return useMemo(() => {
    return [
      {
        label: <IconTab label={t('find')} icon={SearchOutlinedIcon} index={ACTIV8_TABS.FIND} />,
        disabled: false,
      },
      {
        label: <IconTab label={t('studio')} icon={AutoFixHighOutlinedIcon} index={ACTIV8_TABS.STUDIO} />,
        disabled: false,
        // tooltip: t('comingSoon'),
      },
      {
        label: <IconTab label={t('messages')} icon={DrawOutlinedIcon} index={ACTIV8_TABS.MESSAGES} />,
        disabled: false,
        // tooltip: t('comingSoon'),
      },
      {
        label: <IconTab label={t('story')} icon={RttRoundedIcon} index={ACTIV8_TABS.STORY} />,
        disabled: false,
        // tooltip: t('comingSoon'),
      },
    ];
  }, [t, projectVariant]);
};

export default useActiv8Tabs;
